import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";

export const useResubmitChangeOrder = (
	retailOrderID: number,
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/resubmit-change-order",
				{
					retailOrderID: retailOrderID
				}) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when resubmitting the change order: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
